import Skeleton from 'react-loading-skeleton';
import './style.scss';

const MenuGroupImprovementListRowSkeleton = (): JSX.Element => {
  return (
    <>
      <div className="d-flex flex-row align-items-center w-40 pr-4">
        <Skeleton width={150} height={19.2} />
      </div>
      <div className="d-flex flex-row align-items-center w-30">
        <Skeleton width={40} height={19.2} />
      </div>
    </>
  );
};

export default MenuGroupImprovementListRowSkeleton;
